var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.826 6.77401L17.226 3.17401C17.1699 3.1184 17.1034 3.07441 17.0303 3.04455C16.9572 3.01469 16.879 2.99955 16.8 3.00001H15.6V7.80001C15.6 8.11827 15.4736 8.4235 15.2485 8.64854C15.0235 8.87358 14.7183 9.00001 14.4 9.00001H9.6C9.28174 9.00001 8.97652 8.87358 8.75147 8.64854C8.52643 8.4235 8.4 8.11827 8.4 7.80001V3.00001H4.8C4.32261 3.00001 3.86477 3.18965 3.52721 3.52722C3.18964 3.86478 3 4.32262 3 4.80001V19.2C3 19.6774 3.18964 20.1352 3.52721 20.4728C3.86477 20.8104 4.32261 21 4.8 21H6V15.6C6 15.1226 6.18964 14.6648 6.52721 14.3272C6.86477 13.9897 7.32261 13.8 7.8 13.8H16.2C16.6774 13.8 17.1352 13.9897 17.4728 14.3272C17.8104 14.6648 18 15.1226 18 15.6V21H19.2C19.6774 21 20.1352 20.8104 20.4728 20.4728C20.8104 20.1352 21 19.6774 21 19.2V7.20001C21.0005 7.12105 20.9853 7.04277 20.9555 6.96967C20.9256 6.89656 20.8816 6.83007 20.826 6.77401Z",
    color: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60156 3H14.4016V7.8H9.60156V3Z",
    color: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1992 15H7.79922C7.64009 15 7.48748 15.0632 7.37495 15.1757C7.26243 15.2883 7.19922 15.4409 7.19922 15.6V21H16.7992V15.6C16.7992 15.4409 16.736 15.2883 16.6235 15.1757C16.511 15.0632 16.3583 15 16.1992 15Z",
    color: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save_icon.967252b0.svg";
export { ForwardRef as ReactComponent };